import auth from "./auth"
import org from "./org"
import activity from "./activity"
import integrations from "./integrations"
import leadWorkflow from "./lead-workflow"
import apiKey from "./api-key"
import brand from "./brand"
import asset from "./asset"
import lead from "./lead"
import others from "./others"
import approvedURLs from "./approved-urls"
import monitor from "./monitor"
import contactForms from "./contact-forms"
import rateflow from "./rateflow"
import loanOfficer from "./loan-officer"
import pricingSets from "./pricing-sets"
import dashboard from "./dashboard"
import subscriptions from "./subscriptions"
import configAdmin from "./config-admin"
import billing from "./billing"
import pendingSubscriptions from "./pending-subscriptions"
import pendingSubscriptionEvents from "./pending-subscription-events"
import connectors from "./connectors"
import payment from "./payment"
import cancelRequest from "./cancel-request"
import channelLeads from "./channel-leads"
import billingConfig from "./billing-config"
import followupFilters from "./followup-filters"
import diagnostics from "./diagnostics"

const bbApi = {
  auth,
  org,
  activity,
  brand,
  leadWorkflow,
  integrations,
  apiKey,
  asset,
  lead,
  others,
  approvedURLs,
  monitor,
  contactForms,
  rateflow,
  loanOfficer,
  pricingSets,
  dashboard,
  subscriptions,
  configAdmin,
  billing,
  pendingSubscriptions,
  pendingSubscriptionEvents,
  connectors,
  payment,
  cancelRequest,
  channelLeads,
  billingConfig,
  followupFilters,
  diagnostics
}

export default bbApi
